<template>
  <div class="flex-col gap-y-lg">
    <div data-dusk="insurance-filter" class="flex-row justify-content-end align-items-center">
      <filter-component :customer-id="customerId"></filter-component>
    </div>

    <div class="flex-col gap-y-md">
      <skeleton-results v-if="!filterLoaded"></skeleton-results>
      <packages-and-policies v-if="filterLoaded" :customer-id="customerId">

      </packages-and-policies>
    </div>
  </div>
</template>

<script>
import FilterComponent from './FilterComponent.vue';
import { mapActions, mapState, mapMutations } from 'vuex';
import PackagesAndPolicies from './PackagesAndPolicies.vue';
import SkeletonResults from './SkeletonResults.vue';

export default {
  name: "PaneComponent",
  components: {
    SkeletonResults,
    PackagesAndPolicies,
    FilterComponent,
  },
  props: {
    customer: {
      id: {
        type: Number,
        required: true,
      }
    },
    customerId: {
      type: Number,
      required: true,
    }
  },
  computed: {
    ...mapState(`$_policy_page`, {
      displayState: 'displayState',
      filterLoaded: 'filterLoaded',
      loading: 'loading',
    })
  },

  methods: {
    onTabClick(type) {
      const clone = {...this.displayState};
      clone[type] = !clone[type];
      this.setDisplayState(clone);
      this.saveDisplayState()
    },
    ...mapMutations(`$_policy_page`, {
      setDisplayState: 'SET_DISPLAY_STATE',
    }),
    ...mapActions(`$_policy_page`, {
      getPolicyPageForCustomer: 'getPolicyPageForCustomer',
      saveDisplayState: 'saveDisplayState',
    })
  },
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
